/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules>): BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules {
        let obj = Object.assign(new BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules(), model);
        BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules>): BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules {
        if (!model) return null;
        return BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.newInstance(<BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules) {
        if (!obj) return;

        models.BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Rules to apply on provided tenant.
     */
    tenant_id: string;

    /**
     * Apply rules initiated User Id
     */
    user_id: string;

}
